import type { FC } from 'react';
import { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthorizationRequired from '@/pages/AuthorizationRequired';
import useAccess from '@/hooks/useAccess';

interface Props {
  section: string;
}

const AmaruGuard: FC<Props> = (props) => {
  const { hasAccess, isAuthenticated } = useAccess();
  const { section } = props;
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isAuthenticated()) {
    return <AuthorizationRequired />;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }
  return hasAccess(section) ? <Outlet /> : <AuthorizationRequired />;
};

export default AmaruGuard;
